import { METRIC_TYPE_ICONS } from "@/metrics/registry"
import {
  AlignLeft,
  ArrowRightLeft,
  Clock,
  Coins,
  FileText,
  Filter,
  Flag,
  Frown,
  Gauge,
  MessagesSquare,
  Mic,
  Music,
  Music2,
  Play,
  Repeat2,
  ShieldOff,
  Smile,
  Timer,
  Volume2,
  Waves,
  Wrench,
  Zap,
  type LucideIcon,
} from "lucide-react"

/**
 * Icons for the Add-a-metric catalog.
 *
 * Built on top of the existing `METRIC_TYPE_ICONS` so the two modals never drift
 * — every manager that already had an icon keeps exactly the one it had. This
 * only fills the gaps: managers the old picker never listed (the automatics, the
 * trace family, and the audio metrics that only existed in the catalog).
 */
const ADDITIONAL_METRIC_ICONS: Record<string, LucideIcon> = {
  // Observations that are now filed under their real category
  audio_duration_metric_manager: Timer,
  turn_count_metric_manager: MessagesSquare,
  manager_time_to_first_audio: Play,
  manager_latency: Clock,
  manager_end_reason: Flag,

  // Audio
  manager_music_detection: Music,
  manager_signal_to_noise_ratio: Waves,
  manager_phonemes_per_second: Gauge,
  manager_terminal_contour: Music2,
  manager_audio_frequency: Filter,
  manager_audio_sentiment: Smile,
  manager_agent_needs_reprompting: Clock,
  interruption_rate_manager: ArrowRightLeft,

  // Transcript
  manager_user_frustration: Frown,
  manager_agent_refusal: ShieldOff,
  manager_sentimentanalysis: Smile,
  manager_words_per_message: AlignLeft,
  manager_agent_fails_to_respond: Clock,
  manager_persona_role_flip: Repeat2,

  // Traces
  manager_llm_token_usage: Coins,
  manager_tool_call_rate: Wrench,
  manager_llm_ttfb: Zap,
  manager_stt_ttfb: Mic,
  manager_tts_ttfb: Volume2,
  manager_trace_stt_wer: FileText,
  manager_trace_audio_upload_stt_wer: FileText,
}

const METRIC_ICONS: Record<string, LucideIcon> = {
  ...METRIC_TYPE_ICONS,
  ...ADDITIONAL_METRIC_ICONS,
}

/** Never returns undefined — an unmapped manager still gets a mark, so cards
 *  don't lose their left column and reflow. */
export function metricIconFor(manager: string): LucideIcon {
  return METRIC_ICONS[manager] ?? Gauge
}
